/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcInputComponent),
    multi: true
};

/**
 * Input
 */

export class NgcInputComponent extends ControlComponent {
     dropDownWidth: any;
     displayMember: any;
     items: any;
     minLength: any;
     maxLength: any;
     opened: any;
     placeHolder: any;
     popupZIndex: any;
     query: any;
     renderer: any;
     rtl: any;
     searchMode: any;
     source: any;
     theme: any;
     valueMember: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     *
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-input',
    template: `<jqxInput *ngIf="visible"
                (onChange)="inputChange($event)"
                (onBlur)="inputTouched($event)"
                [disabled] = "disabled"
                [dropDownWidth] = "dropDownWidth"
                [displayMember] = "displayMember"
                [items] = "items"
                [minLength] = "minLength"
                [maxLength] = "maxLength"
                [opened] = "opened"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [query] = "query"
                [renderer] = "renderer"
                [rtl] = "rtl"
                [searchMode] = "searchMode"
                [source] = "source"
                [theme] = "theme"
                [valueMember] = "valueMember"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                </jqxInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dropDownWidth': [{ type: Input, args: ['dropDownWidth', ] },],
'displayMember': [{ type: Input, args: ['displayMember', ] },],
'items': [{ type: Input, args: ['items', ] },],
'minLength': [{ type: Input, args: ['minLength', ] },],
'maxLength': [{ type: Input, args: ['maxLength', ] },],
'opened': [{ type: Input, args: ['opened', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'popupZIndex': [{ type: Input, args: ['popupZIndex', ] },],
'query': [{ type: Input, args: ['query', ] },],
'renderer': [{ type: Input, args: ['renderer', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'searchMode': [{ type: Input, args: ['searchMode', ] },],
'source': [{ type: Input, args: ['source', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'valueMember': [{ type: Input, args: ['valueMember', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Input Module
 */

export class NgcInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcErrorModule],
    exports: [NgcInputComponent],
    declarations: [NgcInputComponent, jqxInputComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
